import { FC } from 'react';
import { Grid } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import { Trans, useTranslation } from 'react-i18next';
import { paymentsInfoLink } from '@configs/variables';
import InfoIcon from '@material-ui/icons/Info';
import storeLogos from '@assets/images/store-logos.svg';
import useStyles from './styles';
import PayButton from '@components/PayButton';
import useStore from '@hooks/useStore';
import { SubmitHandler, useFormContext } from 'react-hook-form';
import { IKushkiCashPaymentData, PartnerFormProps } from '@containers/checkout/payment-form/types';
import { FieldValues } from 'react-hook-form/dist/types';

const KushkiCashForm: FC<PartnerFormProps> = ({ onValidationError = () => null, apiKey }) => {
  const { t } = useTranslation();
  const {
    kushki,
    checkout,
    links: {
      paymentLink: { paymentLinkId, total },
    },
    links: {
      coBrandingConfig: { primaryColor, secondaryColor },
    },
  } = useStore();
  const css = useStyles({ primaryColor, secondaryColor });
  const { handleSubmit } = useFormContext();

  const pay = async (values: IKushkiCashPaymentData) => {
    const data = { ...values, paymentLinkId, amount: +total };
    await kushki.generateCashReference(data, apiKey);
  };

  return (
    <>
      <Grid container spacing={1}>
        <Grid item xs={11} data-testid="cash-info">
          {t('checkoutScreen.payment.methods.cash.info')}
        </Grid>
        <Grid item xs={1}>
          <Tooltip
            arrow
            interactive
            placement="bottom-end"
            data-testid="payment-links-ifo-tooltip"
            title={
              <Trans i18nKey="checkoutScreen.payment.methods.cash.tooltipCashStoreDetails">
                <a
                  data-testid="payment-links-ifo-link"
                  href={paymentsInfoLink}
                  target="_blank"
                  rel="noreferrer noopener"
                />
              </Trans>
            }
            classes={{
              tooltip: css.tooltipCashStoreDetails,
              arrow: css.tooltipCashStoreDetailsArrow,
            }}
          >
            <InfoIcon fontSize="small" className={css.infoIcon} />
          </Tooltip>
        </Grid>
      </Grid>

      <div className={`${css.brands} store-brands`}>
        <img data-testid="store-brands" src={storeLogos} className="brand" />
      </div>

      <PayButton
        onClick={handleSubmit(pay as SubmitHandler<FieldValues>, onValidationError)}
        disabled={kushki.isProcessing || !checkout.isAllowedToPayWithCash}
        loading={kushki.isProcessing}
        label={t('checkoutScreen.payment.methods.submit')}
      />
    </>
  );
};

export default KushkiCashForm;
